import { Helmet } from 'react-helmet-async';

export function WebsiteSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "AI ToolHub",
    "alternateName": "AIToolHub.ai",
    "url": "https://aitoolhub.ai",
    "description": "Explore 500+ curated AI tools with expert reviews, pricing, alternatives, and side-by-side comparisons — find the perfect AI tool for any task.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://aitoolhub.ai/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@type": "Organization",
      "name": "AI ToolHub",
      "url": "https://aitoolhub.ai"
    },
    "inLanguage": ["en-US", "ar-AE"]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
